var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"data":_vm.resources,"columns":_vm.columns,"size":"small","highlight-row":"","stripe":"","max-height":"700"},scopedSlots:_vm._u([{key:"bank_name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.bank_account ? row.bank_account.bank_name : '')+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }